import { font_family_detailed, all_font_families } from '../gb-helper/font_family_detailed';
import inline_notice from '../icons/inline_noticel'
import IconPicker  from './icon-picker/index';
import color_palette_list from '../gb-helper/color_palette';


const { registerBlockType } = wp.blocks;
const { __ } = wp.i18n;
const {InspectorControls,RichText}     =   wp.editor;
const {PanelBody, PanelRow,SelectControl,Dashicon,Card, CardBody,Button,
    RangeControl,ColorIndicator,ColorPalette} = wp.components;

registerBlockType( 'blocksbakery/inline-notice', {
    title:                              __( 'Inline Notice', 'blocks-bakery' ),
    description:                        __(
        'This block helps you add an inline notice.',
        'blocks-bakery'
    ),

     // common, formatting, layout, widgets, embed
     category:                           'blocks-bakery',
     icon:                               inline_notice.inline_notice,
     keywords: [
         __( 'Inline Notice', 'blocks-bakery' ),
         __( 'Notice', 'blocks-bakery' ),
         __( 'Inline', 'blocks-bakery' )
     ],

    attributes: {      
        primary_heading:{
            type:       'html',
            default:    'h4',
        },
        primary_heading_val:
        {
            type:'string',
            default : 'Notice text',
        },
        icon_selector:
        {
            type:'string',
            default:'fas fa-window-close',
        },

        //Colors of content
        title_color:
        {
          type:'string',
        },
        dispDismis:{
            type:'string',
            
        },
        highlight_bg_color:
        {
            type:'string',
        },
        content_color:
        {
            type:'string',
        },
        content_bg_color:
        {
            type :'string',
        },
        dismiss_icon_color:
        {
            type :'string',
        },
        content_cont:
        {
                type:'string',
                default:'Add Notice text..',
        },


        // changes typography of title 
        title_size:{
            type : "number",
        },
        dispModern:{
            type:'string',
            default:'block'
        },
        dispDefault:{
            type:'string',
            default:'none'
        },
        title_family:{
            type:'string',
            default:'ABeeZee'
        },
        title_weight:{
            type:'string',
            default:"regular"
        },
        title_lheight:
        {
            type:'number',
            default:1.5
        },


        // content typography

        content_size:{
            type : 'number',
            default:20
        },
        content_family:{
            type:'string',
            default:"ABeeZee"
        },
        content_weight:{
            type:'string',
            default:"regular"
        },
        content_lheight:
        {
            type:'number',
            default:1.5
        },
        title_tb_padding: 
        {
            type:'number',
            default:0
        },
        title_lr_padding: 
        {
            type:'number',
            default:0
        },
        content_tb_padding: 
        {
            type:'number',
            default:0
        },
        
        content_lr_padding: 
        {
            type:'number',
            default:0
        },
        icon_showhide:{
            type:'string',
            default:'block'
        },
        layout_option: {
            type : 'string',
            default:'modren'
        },
        default_highlight_width:
        {
            type:'number',
            default:10,
        },
        layout_setting1:{
            type:"string"
        },
        layout_setting2:{
            type:"string"
        },
        icon_setting_save:{
            type:"string"
        },
        titlempxset:{
            type:"string",
            default:"px",
        },
        title_lineheightempx:{
            type:"string",
            default:"em",
        },
        contentempx:{
            type:"string",
            default:'px',
        },
        content_lineheightempx:{
            type:"string",
            default:'em',
        },
        
    },


     edit:(props)=>{

        var index = font_family_detailed.findIndex(x => x.family === props.attributes.title_family);
        var font_weight = font_family_detailed[index].variants
        var font_weight_list = []
        for (var i = 0; i < font_weight.length; i++) {
            font_weight_list.push({ label: font_weight[i], value: font_weight[i] })
        }
    
        var cindex = font_family_detailed.findIndex(x => x.family === props.attributes.title_family);
        var font_weight_content = font_family_detailed[cindex].variants
        var font_weight_content = []
        for (var i = 0; i < font_weight_content.length; i++) {
            font_weight_content.push({ label: font_weight_content[i], value: font_weight_content[i] })
        }

        const title_toggle = () => 
        {
            var x = document.getElementById('title-toggle')
            if(x.style.display==="none")
            {
                x.style.display="block";
            }
            else 
            {
                x.style.display="none";
            }
        };
        const title_px = () => 
        {
                const y= document.getElementById("title_u_px");
                const z = document.getElementById("title_u_em");      
                y.style.textDecoration = "underline"
                z.style.textDecoration = "none"
                props.setAttributes({titlempxset:'px'})              
        };
        const title_em = () => 
        {
                const y= document.getElementById("title_u_em");
                const z = document.getElementById("title_u_px");     
                y.style.textDecoration = "underline"
                z.style.textDecoration = "none"
                props.setAttributes({titlempxset:'em'})   
        };

        const title_lineheightpx = () => 
        {
            const x= document.getElementById("title_ul_px");
            const y= document.getElementById("title_ul_em");    
            x.style.textDecoration = "underline"
            y.style.textDecoration = "none"
            props.setAttributes({title_lineheightempx:'px'})
        };

        const title_lineheightem = () => 
        {
            const x= document.getElementById("title_ul_px");
            const y= document.getElementById("title_ul_em");    
            x.style.textDecoration = "none"
            y.style.textDecoration = "underline"
            props.setAttributes({title_lineheightempx:'em'})
        };


        //Line Height EM and px For Content 
          
        const content_lineheightpx = () => 
        {
            const x= document.getElementById("content_ul_px");
            const y= document.getElementById("content_ul_em");    
            x.style.textDecoration = "underline"
            y.style.textDecoration = "none"
            props.setAttributes({content_lineheightempx:'px'})
        };

        const content_lineheightem = () => 
        {
            const x= document.getElementById("content_ul_px");
            const y= document.getElementById("content_ul_em");    
            x.style.textDecoration = "none"
            y.style.textDecoration = "underline"
            props.setAttributes({content_lineheightempx:'em'})
        };


        //End of height em px
        const content_toggle = () =>
        {
                const x = document.getElementById("content-toggle");
                if(x.style.display==="none")
                {
                    x.style.display="block";
                }
                else
                {
                    x.style.display="none";
                }
        };
 
            const content_px = () => 
            {
                    const y= document.getElementById("content_u_px");
                    const z = document.getElementById("content_u_em");
                    y.style.textDecoration = "underline"
                    z.style.textDecoration = "none"
                    props.setAttributes({contentempx:'px'})
            };
            const content_em = () => 
            {
                    const y= document.getElementById("content_u_em");
                    const z = document.getElementById("content_u_px");
                    y.style.textDecoration = "underline"
                    z.style.textDecoration = "none"
                    props.setAttributes({contentempx:'em'})    
            };
            const dismiss=(new_val)=>{
                var x = document.getElementById('dismiss');
                var y = document.getElementById('allow-dismiss');
                var z = document.getElementById('dismiss-icon-color');
                var a = document.getElementById('dismiss2');
                if(new_val==='none'){
                    x.style.display='none'
                    y.style.display='none'
                    z.style.display='none'
                    a.style.display='none'
                    props.setAttributes({dispDismis: 'none'})
                }
                else if(new_val==='block'){
                    x.style.display='block'
                    y.style.display='block'
                    z.style.display='block'
                    a.style.display='block'
                    props.setAttributes({dispDismis: 'block'})

                }
            }
            const reset_title =   () => {
                props.setAttributes({title_family:"ABeeZee"});
                props.setAttributes({title_size:19});
                props.setAttributes({title_weight:"regular"});
                props.setAttributes({title_lheight:1.5});
            }
            const reset_content =   () => {
                props.setAttributes({content_family:"ABeeZee"});
                props.setAttributes({content_size:20});
                props.setAttributes({content_weight:"regular"});
                props.setAttributes({content_lheight:1.5});
            }
            const layouts=(new_val) =>
            {
                if(new_val==='modren')
                {
                    props.setAttributes({dispModern: 'block'})
                    props.setAttributes({dispDefault: 'none'})
                }
                else if(new_val==='default')
                {
                    props.setAttributes({dispModern: 'none'})
                    props.setAttributes({dispDefault: 'block'})
                }
            }
    return(
            <div>
           <InspectorControls>
           <PanelBody title={__("General")} initialOpen={true}>
           <SelectControl
                label="Layout"
                options={ [
                    { label: 'Modern', value: 'modren' },
                    { label: 'Default', value: 'default' },
                ] }
                onChange={ ( new_val ) => {
                    props.setAttributes({ layout_option: new_val })
                    layouts(new_val)
                }}
                value={props.attributes.layout_option}
            />
            <div style={{display:props.attributes.dispDefault}}>
            <div className="range-controler" style={{display:"flex"}}>
            <div style={{marginRight:"10px",width:"100%"}}>
                        <RangeControl
                                label="Highlight width"
                                min={ 10 }
                                max={ 50 }
                                step={0.1}
                                initialPosition={10}
                                value={props.attributes.default_highlight_width}
                                onChange={(new_val)=>{
                                    props.setAttributes({default_highlight_width:new_val})
                                }}   
                            />
                        </div>
                        <Button style={{
                        background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba", marginTop:"25px"
                        }}
                        onClick={() => {
                        props.setAttributes({default_highlight_width:10})
                        }}> Reset 
                        </Button>
            </div>
            </div>
            <hr/>
            <p>Primary Heading</p>
            <SelectControl 
                    label="Tag"
                    options={ [
                        { label: 'H1', value: 'h1'},
                        { label: 'H2', value: 'h2' },
                        { label: 'H3', value: 'h3' },
                        { label: 'H4', value: 'h4' },
                        { label: 'H5', value: 'h5' },
                        { label: 'H6', value: 'h6' },
                        { label: 'Span', value: 'span' },
                        { label: 'P', value: 'p' },
                    ] }
                    value={props.attributes.primary_heading} 
                    onChange={ ( new_val ) => {
                        props.setAttributes({ primary_heading: new_val })
                    }} 
                />
                <SelectControl
                label="Notice Display"
                options={ [
                    { label: 'Not Allow', value: 'none' },
                    { label: 'Allow To Dismiss', value: 'block' },
                ] }
                onChange={ ( new_val ) => {
                    props.setAttributes({ icon_showhide: new_val })
                    dismiss(new_val)
                }}
                value={props.attributes.icon_showhide}
            />
            <hr></hr>
            <div id="allow-dismiss" style={{display:props.attributes.dispDismis}} >
                <p>Icon</p>
                    <IconPicker
                            allowReset={false}
                            value={props.attributes.icon_selector}         
                            onChange={(newIcon) => props.setAttributes({ icon_selector: newIcon })}
                   />
            </div>
            <hr/>
            
            <div id="colors">
                    <p>Colors</p>
                    <p>Title Color <span> <ColorIndicator
                style={{backgroundColor:props.attributes.title_color}}/></span></p>
                <ColorPalette
            colors={color_palette_list}
            onChange={ ( new_val ) => {
                props.setAttributes({ title_color: new_val }) 
            }}
            value={props.attributes.title_color}
        />    
        <hr/>
        <p>Highlight Color<span> <ColorIndicator                
                style={{backgroundColor:props.attributes.highlight_bg_color}}/></span></p>
                <ColorPalette
            colors={color_palette_list}
            onChange={ ( new_val ) => {
                props.setAttributes({ highlight_bg_color: new_val })  
            }}
            value={props.attributes.highlight_bg_color}
        />    
        <hr/>

        <p>Content Color<span> <ColorIndicator
                style={{backgroundColor:props.attributes.content_color}}/></span></p>
                <ColorPalette
            colors={color_palette_list}
            onChange={ ( new_val ) => {
                props.setAttributes({ content_color: new_val }) 
            }}
            value={props.attributes.content_color}
        />    
        <hr/>
        <p>Content Background Color<span> <ColorIndicator  
                style={{backgroundColor:props.attributes.content_bg_color}}/></span></p>
                <ColorPalette
            colors={color_palette_list}
            onChange={ ( new_val ) => {
                props.setAttributes({ content_bg_color: new_val })
             
            }}
            value={props.attributes.content_bg_color}   
        />    
        <hr/>
            
        <div style={{display:props.attributes.dispDismis}} id="dismiss-icon-color">
        <p>Dismiss Icon Color<span> <ColorIndicator        
                style={{backgroundColor:props.attributes.dismiss_icon_color}}/></span></p>
                <ColorPalette
            colors={color_palette_list}
            onChange={ ( new_val ) => {
                props.setAttributes({ dismiss_icon_color: new_val })   
            }}
            value={props.attributes.dismiss_icon_color}
            allowReset={true}
        />  
        <hr></hr>
        </div>    
            </div>
            <PanelRow>
                <h4 style={{color:"black"}}>Typography</h4>
            </PanelRow>
            <PanelRow>
            <p>Title</p>
            <div>
            <Button style={{paddingLeft:7,paddingRight:7}}><span><Dashicon icon="image-rotate" style={{fontSize:15}} onClick={reset_title}/></span></Button>
            <Button style={{paddingLeft:7,paddingRight:7}}><span><Dashicon icon="admin-tools" onClick={title_toggle}style={{fontSize:15}} /></span></Button>
            </div>
            </PanelRow>
            <Card id="title-toggle" style={{display:"none"}}>
             <CardBody style={{paddingTop:16,paddingBottom:16,paddingLeft:10, paddingRight:10}}>
                <div style={{display:"flex",alignItems:"center"}}>
                <p style={{marginRight:50,marginTop:10}}>Font Size</p>
                <Button style={{padding:1,marginRight:4,boxShadow:0,height:20,backgroundColor:"#e4e5e5",color:"#23282d",borderRadius:"50%"}}>
               <span> <Dashicon icon="desktop" style={{fontSize:15}}/></span></Button> 
               <Button style={{padding:1,marginRight:4,boxShadow:0,height:20,backgroundColor:"#e4e5e5",color:"#23282d",borderRadius:"50%"}}>
               <span><Dashicon icon="tablet" style={{fontSize:15}}/></span></Button> 
               <Button style={{padding:1,marginRight:4,boxShadow:0,height:20,backgroundColor:"#e4e5e5",color:"#23282d",borderRadius:"50%"}}> 
                <span><Dashicon icon="phone" style={{fontSize:15}}/></span></Button>
                <Button  onClick={title_px} id="title_u_px" style={{textDecoration:"underline", fontSize:12,paddingLeft:5,paddingRight:5}}><span style={{height:20}}>px</span></Button>
                <Button primaray onClick={title_em} id="title_u_em" style={{fontSize:12,padding:0}} ><span style={{height:20}}>em</span></Button>
                </div>
 
                <div className="range-controller-main">
                <div className="textcoloring">
                </div>
                <div className="range-controler" style={{display:"flex"}}> 
                <div style={{marginRight:"10px",width:"100%"}}>
                <RangeControl
                beforeIcon="editor-textcolor"
                min={ 0 }
                max={ 100 }
                step={0.1}
                initialPosition = {19}
                value={props.attributes.title_size}
                onChange={(new_val)=>{
                    props.setAttributes({title_size:new_val})
                }}
                />
                </div>
               <Button style={{
                    background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba"
                    }}
                onClick={() => {
                     props.setAttributes({title_size:19})
                    }}> Reset 
                </Button>
                </div>
      
                 <SelectControl
                 label="Font Family"
                 options={all_font_families}
                onChange={ ( new_val ) => {
                    props.setAttributes({ title_family: new_val })
                }}
                value={props.attributes.title_family}    
                />

                <SelectControl
                label="Font Weight"
                options={font_weight_list}
                onChange={ ( new_val ) => {
                    props.setAttributes({ title_weight: new_val })
                }}
                value={props.attributes.title_weight}
                />

                <div style={{display:"flex",alignItems:"center"}}>
                <p style={{marginRight:43,marginTop:10}}>Line Height</p>
                <Button style={{padding:1,marginRight:4,boxShadow:0,height:20,backgroundColor:"#e4e5e5",color:"#23282d",borderRadius:"50%"}}>
               <span> <Dashicon icon="desktop" style={{fontSize:15}}/></span></Button>       
               <Button style={{padding:1,marginRight:4,boxShadow:0,height:20,backgroundColor:"#e4e5e5",color:"#23282d",borderRadius:"50%"}}>
               <span><Dashicon icon="tablet" style={{fontSize:15}}/></span></Button>     
               <Button style={{padding:1,marginRight:4,boxShadow:0,height:20,backgroundColor:"#e4e5e5",color:"#23282d",borderRadius:"50%"}}>
                <span><Dashicon icon="phone" style={{fontSize:15}}/></span></Button>
                <Button  onClick={title_lineheightpx} id="title_ul_px" style={{fontSize:12,paddingLeft:5,paddingRight:5}}><span style={{height:20}}>px</span></Button>
                <Button primaray onClick={title_lineheightem} id="title_ul_em" style={{textDecoration:"underline", fontSize:12,padding:0}} ><span style={{height:20}}>em</span></Button>
                </div>

                <div className="range-controler" style={{display:"flex"}}>
                <div style={{marginRight:"10px",width:"100%"}}>     
                <RangeControl
                beforeIcon="editor-textcolor"
                min={ 0 }
                max={ 300 }
                step={0.1}
                initialPosition={1.5}
                value={props.attributes.title_lheight}
                onChange = {( new_val )=>{
                    props.setAttributes({title_lheight:new_val})
                }} 
                />
                </div>
                <Button style={{
                    background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba"
                    }}
                    onClick={() => {
                        props.setAttributes({title_lheight:1.5})
                    }}> Reset 
                </Button>
                </div>
                </div>
            </CardBody>
            </Card>  
              
            <PanelRow>
            <p>Content</p>
            <div>
            <Button style={{paddingLeft:7,paddingRight:7}}><span><Dashicon icon="image-rotate" style={{fontSize:15}} onClick={reset_content}/></span></Button>
            <Button style={{paddingLeft:7,paddingRight:7}}><span><Dashicon icon="admin-tools" onClick={content_toggle}style={{fontSize:15}} /></span></Button>
            </div>
            </PanelRow>
            <Card id="content-toggle" style={{display:"none"}}>
             <CardBody style={{paddingTop:16,paddingBottom:16,paddingLeft:10, paddingRight:10}}>
                <div style={{display:"flex",alignItems:"center"}}>
                <p style={{marginRight:50,marginTop:10}}>Font Size</p>
                <Button style={{padding:1,marginRight:4,boxShadow:0,height:20,backgroundColor:"#e4e5e5",color:"#23282d",borderRadius:"50%"}}>
               <span> <Dashicon icon="desktop" style={{fontSize:15}}/></span></Button>
               <Button style={{padding:1,marginRight:4,boxShadow:0,height:20,backgroundColor:"#e4e5e5",color:"#23282d",borderRadius:"50%"}}>
               <span><Dashicon icon="tablet" style={{fontSize:15}}/></span></Button>
               <Button style={{padding:1,marginRight:4,boxShadow:0,height:20,backgroundColor:"#e4e5e5",color:"#23282d",borderRadius:"50%"}}>
                <span><Dashicon icon="phone" style={{fontSize:15}}/></span></Button>
        
                <Button  onClick={content_px} id="content_u_px" style={{textDecoration:"underline", fontSize:12,paddingLeft:5,paddingRight:5}}><span style={{height:20}}>px</span></Button>
                <Button  onClick={content_em} id="content_u_em" style={{fontSize:12,padding:0}} ><span style={{height:20}}>em</span></Button>
                </div>
   
            <div className="range-controler" style={{display:"flex"}}>
            <div style={{marginRight:"10px",width:"100%"}}>
            <RangeControl
                step={0.1} 
                min={ 0 }
                max={ 100 }
                initialPosition = {20}
                value={props.attributes.content_size}
                onChange={(new_val)=>{
                    props.setAttributes({content_size:new_val})
                }}    
            />
            </div>
            <Button style={{
                background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba"
                }}
                onClick={() => {
                props.setAttributes({content_size:20})
                }}> Reset 
            </Button>
            </div>

            <SelectControl
                 label="Font Family"
                 options={all_font_families}
                onChange={ ( new_val ) => {
                    props.setAttributes({ content_family: new_val })
                }}
                value={props.attributes.content_family}    
            />

            <SelectControl
                label="Font Weight"
                options={font_weight_content}
                onChange={ ( new_val ) => {
                    props.setAttributes({ content_weight: new_val })
                }}
                value={props.attributes.content_weight}
            />

            <div style={{display:"flex",alignItems:"center"}}>
                <p style={{marginRight:43,marginTop:10}}>Line Height</p>
                <Button style={{padding:1,marginRight:4,boxShadow:0,height:20,backgroundColor:"#e4e5e5",color:"#23282d",borderRadius:"50%"}}>
               <span> <Dashicon icon="desktop" style={{fontSize:15}}/></span></Button>   
               <Button style={{padding:1,marginRight:4,boxShadow:0,height:20,backgroundColor:"#e4e5e5",color:"#23282d",borderRadius:"50%"}}>
               <span><Dashicon icon="tablet" style={{fontSize:15}}/></span></Button>
               <Button style={{padding:1,marginRight:4,boxShadow:0,height:20,backgroundColor:"#e4e5e5",color:"#23282d",borderRadius:"50%"}}>
                <span><Dashicon icon="phone" style={{fontSize:15}}/></span></Button>
              
                <Button  onClick={content_lineheightpx} id="content_ul_px" style={{fontSize:12,paddingLeft:5,paddingRight:5}}><span style={{height:20}}>px</span></Button>
                <Button  onClick={content_lineheightem} id="content_ul_em" style={{textDecoration:"underline",fontSize:12,padding:0}} ><span style={{height:20}}>em</span></Button>
                </div>

            <div className="range-controler" style={{display:"flex"}}>  
            <div style={{marginRight:"10px",width:"100%"}}>
            <RangeControl       
                beforeIcon="editor-textcolor"
                min={ 0 }
                max={ 300 }
                step={0.1}
                initialPosition={1.5}
                value={props.attributes.content_lheight}
                onChange = {( new_val )=>{
                    props.setAttributes({content_lheight:new_val})   
                }}    
            />
            </div>
            <Button style={{
                background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba"
                }}
                onClick={() => {
                props.setAttributes({content_lheight:1.5})
                }}> Reset 
            </Button>                         
            </div>
            </CardBody>
            </Card>  
              
            <hr/>

            <PanelRow>
                <h4 style={{color:"black"}}>Title Padding (px)</h4>
            </PanelRow>
            <div className="range-controler" style={{display:"flex"}}>
            <div style={{marginRight:"10px",width:"100%"}}>
            <RangeControl
                label={<svg width="20" height="20"><path fill="#999" d="M17 0.999c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17-0.001h-14c-1.657 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.657 0 3-1.343 3-3v-14c0-1.656-1.343-3-3-3v0z"></path><path fill="#575E67" d="M17 0.983h-14c-1.103 0-2 0.896-2 2v0.797h18v-0.797c0-1.103-0.896-2-2-2z"></path><path fill="#575E67" d="M3 19.031h14c1.103 0 2-0.896 2-2v-0.797h-18v0.797c0 1.104 0.896 2 2 2z"></path></svg>}
                step={0.1}
                initialPosition={0}
                min={ 0 }
                max={ 50 }
                value={props.attributes.title_tb_padding}
                onChange={(new_val)=>{
                    props.setAttributes({title_tb_padding:new_val})
                }}   
            />
            </div>
            <Button style={{
                background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba", marginTop:"25px"
                }}
                onClick={() => {
                props.setAttributes({title_tb_padding:0})
                }}> Reset 
            </Button>
            </div>

            <div className="range-controler" style={{display:"flex"}}>
            <div style={{marginRight:"10px",width:"100%"}}>
            <RangeControl
                label={<svg width="20" height="20"><path fill="#999" d="M17 0.999c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17-0.001h-14c-1.657 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.656 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3v0z"></path><path fill="#575E67" d="M19.016 16.999v-14c0-1.103-0.896-2-2-2h-0.797v18h0.797c1.103 0 2-0.896 2-2z"></path><path fill="#575E67" d="M0.968 2.999v14c0 1.103 0.896 2 2 2h0.797v-18h-0.797c-1.104 0-2 0.897-2 2z"></path></svg>}
                step={0.1}
                initialPosition={0}
                min={ 0 }
                max={ 50 }
                value={props.attributes.title_lr_padding}
                onChange={(new_val)=>{
                    props.setAttributes({title_lr_padding:new_val})
                }}
            />
            </div>
            <Button style={{
                background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba", marginTop:"25px"
                }}
                onClick={() => {
                props.setAttributes({title_lr_padding:0})
                }}> Reset 
            </Button>
            </div>

            <PanelRow>
            <h4 style={{color:"black"}}>Content Padding (px)</h4>
            </PanelRow>

            <div className="range-controler" style={{display:"flex"}}>
            <div style={{marginRight:"10px",width:"100%"}}>
            <RangeControl
                label={<svg width="20" height="20"><path fill="#999" d="M17 0.999c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17-0.001h-14c-1.657 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.657 0 3-1.343 3-3v-14c0-1.656-1.343-3-3-3v0z"></path><path fill="#575E67" d="M17 0.983h-14c-1.103 0-2 0.896-2 2v0.797h18v-0.797c0-1.103-0.896-2-2-2z"></path><path fill="#575E67" d="M3 19.031h14c1.103 0 2-0.896 2-2v-0.797h-18v0.797c0 1.104 0.896 2 2 2z"></path></svg>}
                step={0.1}
                min={ 0 }
                max={ 50 }
                initialPosition={0}
                value={props.attributes.content_tb_padding}
                onChange={(new_val)=>{
                    props.setAttributes({content_tb_padding:new_val})
                }}       
            />
            </div>
            <Button style={{
                background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba", marginTop:"25px"
                }}
                onClick={() => {
                props.setAttributes({content_tb_padding:0})
                }}> Reset 
            </Button>
            </div>

            <div className="range-controler" style={{display:"flex"}}>
            <div style={{marginRight:"10px",width:"100%"}}>   
            <RangeControl
                label={<svg width="20" height="20"><path fill="#999" d="M17 0.999c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17-0.001h-14c-1.657 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.656 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3v0z"></path><path fill="#575E67" d="M19.016 16.999v-14c0-1.103-0.896-2-2-2h-0.797v18h0.797c1.103 0 2-0.896 2-2z"></path><path fill="#575E67" d="M0.968 2.999v14c0 1.103 0.896 2 2 2h0.797v-18h-0.797c-1.104 0-2 0.897-2 2z"></path></svg>}
                step={0.1}
                min={ 0 }
                max={ 50 }
                initialPosition={0}
                value={props.attributes.content_lr_padding}
                onChange={(new_val)=>{
                    props.setAttributes({content_lr_padding:new_val})
                }}      
            />
            </div>
            <Button style={{
                background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba", marginTop:"25px"
                }}
                onClick={() => {
                props.setAttributes({content_lr_padding:0})
                }}> Reset 
            </Button>
            </div>
            </PanelBody>
           </InspectorControls>

              <div className={props.className}> 
             <div id="modren-layout" style={{display:props.attributes.dispModern}}>
             <div className="bb_inline_layout" style={{backgroundColor:props.attributes.highlight_bg_color,paddingTop:props.attributes.title_tb_padding,paddingBottom:props.attributes.title_tb_padding,paddingLeft:props.attributes.title_lr_padding,paddingRight:props.attributes.title_lr_padding}}> 
                 <RichText
                 tagName={props.attributes.primary_heading}
                 style={{margin:"0px",padding:"20px 15px",color:props.attributes.title_color,
                 fontSize:props.attributes.title_size + props.attributes.titlempxset,
                 fontFamily:props.attributes.title_family,fontWeight:props.attributes.title_weight,
                 lineHeight:props.attributes.title_lheight + props.attributes.title_lineheightempx,
                 width:"90%",
              }}
                  value={props.attributes.primary_heading_val}
                  onChange={(new_val)=>{
                      props.setAttributes({primary_heading_val:new_val})
                  }}
                 id="notice-title"
                 />
                 <div
                 id='dismiss'
                 className={props.attributes.icon_selector}
                 style={{width:"10%",float:"right",
                 marginTop:"-50px",
                 color:props.attributes.dismiss_icon_color,
                  display:props.attributes.dispDismis,
              }}>
               </div>
                  
             </div>
             <div className="bb_inline_layout1" style={{border:"2px solid",borderColor:props.attributes.highlight_bg_color,marginTop:"-20px",padding:"15px",backgroundColor:props.attributes.content_bg_color}}>
                 <RichText
                  tagName="p"
                 style={{
                     
                  fontSize:props.attributes.content_size + props.attributes.contentempx,
                  fontFamily:props.attributes.content_family,
                  fontWeight:props.attributes.content_weight,
                  lineHeight:props.attributes.content_lheight + props.attributes.content_lineheightempx,
                  paddingTop:props.attributes.content_tb_padding,
                  paddingBottom:props.attributes.content_tb_padding,paddingLeft:props.attributes.content_lr_padding,paddingRight:props.attributes.content_lr_padding,color:props.attributes.content_color}}
                 id="notice-descripion"
                 value={props.attributes.content_cont} 
                 onChange={ ( new_val ) => {
                     props.setAttributes({ content_cont: new_val })
                 }} 
             />
             </div>
             </div>
  
             <div id="default-layout" className="bb_inline_layout2" style={{display:props.attributes.dispDefault, padding:"20px 10px",backgroundColor:props.attributes.content_bg_color,borderLeftWidth:props.attributes.default_highlight_width,borderLeftStyle:"solid",borderLeftColor:props.attributes.highlight_bg_color}}>
             <div > 
                 <RichText
                 tagName={props.attributes.primary_heading}
                 style={{margin:"0px",color:props.attributes.title_color,
                 fontSize:props.attributes.title_size + props.attributes.titlempxset,
                 fontFamily:props.attributes.title_family,fontWeight:props.attributes.title_weight,
                 lineHeight:props.attributes.title_lheight + props.attributes.title_lineheightempx,
                 paddingTop:props.attributes.title_tb_padding,paddingBottom:props.attributes.title_tb_padding,paddingLeft:props.attributes.title_lr_padding,paddingRight:props.attributes.title_lr_padding
                 ,width:"90%",
              }}
                  value={props.attributes.primary_heading_val}
                 id="notice-title"
                 />
                 <div 
                 id='dismiss2'
                 className={props.attributes.icon_selector}
                 style={{
                     display: props.attributes.dispDismis, 
                     width:"10%",float:"right",marginTop:"-30px",
                     color:props.attributes.dismiss_icon_color}}
                 />
                     
             </div>
             <div>
                 <RichText
                  tagName="p"
                 style={{
                  fontSize:props.attributes.content_size + props.attributes.contentempx,
                  fontFamily:props.attributes.content_family,fontWeight:props.attributes.content_weight,
                  lineHeight:props.attributes.content_lheight + props.attributes.content_lineheightempx,
                  paddingTop:props.attributes.content_tb_padding,
                  paddingBottom:props.attributes.content_tb_padding,paddingLeft:props.attributes.content_lr_padding,paddingRight:props.attributes.content_lr_padding,color:props.attributes.content_color}}
                 id="notice-descripion"
                 value={props.attributes.content_cont} 
                 onChange={ ( new_val ) => {
                     props.setAttributes({ content_cont: new_val })
                 }} 
             />     
             </div>    
             </div>
             </div>
             </div> 
        )

     },

     save: ( props ) => {
       
         return(
            <div className={props.className}>  
            <div id="modren-layout" style={{display:props.attributes.dispModern}}>
            <div className="bb_inline_layout"  style={{backgroundColor:props.attributes.highlight_bg_color,paddingTop:props.attributes.title_tb_padding,paddingBottom:props.attributes.title_tb_padding,paddingLeft:props.attributes.title_lr_padding,paddingRight:props.attributes.title_lr_padding}}> 
            <RichText.Content
               tagName={props.attributes.primary_heading}
               style={{margin:"0px",padding:"20px 15px",color:props.attributes.title_color,
               fontSize:props.attributes.title_size + props.attributes.titlempxset,
               fontFamily:props.attributes.title_family,fontWeight:props.attributes.title_weight,
               lineHeight:props.attributes.title_lheight + props.attributes.title_lineheightempx,
               width:"90%",
               }}
               value={props.attributes.primary_heading_val}
               id="notice-title"
               />
            <div 
               id='dismiss'
               className={props.attributes.icon_selector}
               style={{width:"10%",float:"right",
               color:props.attributes.dismiss_icon_color,
               marginTop:"-50px",
               display:props.attributes.dispDismis}}
            />
       
           </div>
           <div className="bb_inline_layout1"  style={{border:"2px solid"+props.attributes.highlight_bg_color,marginTop:"-20px",padding:"15px",backgroundColor:props.attributes.content_bg_color}}>
            <RichText.Content
                tagName="p"
                style={{
                fontSize:props.attributes.content_size + props.attributes.contentempx,
                fontFamily:props.attributes.content_family,
                fontWeight:props.attributes.content_weight,
                lineHeight:props.attributes.content_lheight + props.attributes.content_lineheightempx,
                paddingTop:props.attributes.content_tb_padding,
                paddingBottom:props.attributes.content_tb_padding,paddingLeft:props.attributes.content_lr_padding,paddingRight:props.attributes.content_lr_padding,color:props.attributes.content_color}}
               id="notice-descripion"
               value={props.attributes.content_cont}      
           />
           </div>
           </div>

           <div id="default-layout" className="bb_inline_layout2"  style={{display:props.attributes.dispDefault, padding:"20px 10px",backgroundColor:props.attributes.content_bg_color,borderLeftWidth:props.attributes.default_highlight_width,borderLeftStyle:"solid",borderLeftColor:props.attributes.highlight_bg_color}}>
           <div > 
            <RichText.Content
               tagName={props.attributes.primary_heading}
               style={{margin:"0px",color:props.attributes.title_color,
               fontSize:props.attributes.title_size,fontFamily:props.attributes.title_family,fontWeight:props.attributes.title_weight,
               lineHeight:props.attributes.title_lheight + props.attributes.title_lineheightempx,
               paddingTop:props.attributes.title_tb_padding,paddingBottom:props.attributes.title_tb_padding,paddingLeft:props.attributes.title_lr_padding,paddingRight:props.attributes.title_lr_padding
              , width:"90%",
                }}
               value={props.attributes.primary_heading_val}
               id="notice-title"
            />
            <div 
               id='dismiss2'icon_selector
               className={props.attributes.icon_selector}
               style={{display: props.attributes.dispDismis,width:"10%",
               marginTop:"-30px",
               float:"right",color:props.attributes.dismiss_icon_color}}
            />  
           </div>
           <div>
           <RichText.Content
               tagName="p"
               style={{
                fontSize:props.attributes.content_size + props.attributes.contentempx,
                fontFamily:props.attributes.content_family,fontWeight:props.attributes.content_weight,
                lineHeight:props.attributes.content_lheight + props.attributes.content_lineheightempx,
                paddingTop:props.attributes.content_tb_padding,
                paddingBottom:props.attributes.content_tb_padding,paddingLeft:props.attributes.content_lr_padding,paddingRight:props.attributes.content_lr_padding,color:props.attributes.content_color}}
               id="notice-descripion"
               value={props.attributes.content_cont}     
           />
           </div>
           </div>
           </div>
         )
     }
})